import {BaseDTO} from '../../common/models/BaseDTO';

export class AboutDTO extends BaseDTO {
  aboutId: number;
  version: string;
  supportEmail: string;
  updates: string;
  description: string;
}
